
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","stroke":"#434243"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","stroke":"none"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","fill":"none"}})]),_c('path',{attrs:{"d":"M9.181 11.008l1.831-1.826a.278.278 0 00-.393-.394l-1.36 1.358V7.362a1.9 1.9 0 00-1.894-1.9h-2.55a.278.278 0 100 .556h2.55a1.345 1.345 0 011.338 1.343v2.78L7.348 8.789a.278.278 0 00-.393.394l1.832 1.825a.278.278 0 00.394 0z","fill":"#434243","stroke":"#434243","stroke-width":".5"}})])
          )
        }
      }
    